module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.canAdd) ? _c('div', [(_vm.productMainView == 'cartactions') ? _c('button', {
    staticClass: "cta-btn cta-btn-sm",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" Buy Now")]) : _c('button', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" Buy Now")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38d76cac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductCTAActions.vue
// module id = 242
// module chunks = 0